import { render, staticRenderFns } from "./ImportStack.vue?vue&type=template&id=65810d99&scoped=true&"
import script from "./ImportStack.vue?vue&type=script&lang=js&"
export * from "./ImportStack.vue?vue&type=script&lang=js&"
import style0 from "./ImportStack.vue?vue&type=style&index=0&id=65810d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65810d99",
  null
  
)

export default component.exports